import {
  Alert,
  Body,
  Box,
  Heading,
  Money,
  RawMoney,
} from '@edreamsodigeo/prisma-design-system';
import React from 'react';
import { Desktop, Mobile, useTranslation } from '@edreamsodigeo/frontend-core';

export const StepSubtitle = ({ children, ...props }) => (
  <Body type="small" color="neutral.70" {...props}>
    {children}
  </Body>
);

export const StyledPrice = ({ money = {} }) => (
  <Heading
    type="3"
    weight="medium"
    color="primary.50"
    sx={{ display: 'inline' }}
  >
    <Desktop>
      <Body inline type="base" weight="medium" color="positive.70">
        <RawMoney rounded type="positive" currency={money.currency}>
          {money.amount}
        </RawMoney>
      </Body>
    </Desktop>
    <Mobile>
      <Money rounded type="positive" size="small" currency={money.currency}>
        {money.amount}
      </Money>
    </Mobile>
  </Heading>
);

export const PriceOfferAlert = ({ noFeeKey }) => (
  <Box mt="1x_small">
    <Alert theme="soft" type="positive">
      <Desktop>
        <Body inline type="base">
          {noFeeKey}
        </Body>
      </Desktop>
      <Mobile>
        <Body inline type="small">
          {noFeeKey}
        </Body>
      </Mobile>
    </Alert>
  </Box>
);

export const PriceOfferHeaderSubtitle = () => {
  const { t } = useTranslation();
  return (
    <>
      <Box mt="small" mb="1x_small">
        <Mobile>
          <Body type="base" weight="medium">
            {t('pricefreeze.valueprop.step2.subtitle1')}
          </Body>
        </Mobile>
        <Desktop>
          <Body type="small" weight="medium">
            {t('pricefreeze.valueprop.step2.subtitle1')}
          </Body>
        </Desktop>
      </Box>
      <Box mb="2x_big">
        <Mobile>
          <Body type="base">{t('pricefreeze.valueprop.step2.subtitle2')}</Body>
        </Mobile>
        <Desktop>
          <Body type="small">{t('pricefreeze.valueprop.step2.subtitle2')}</Body>
        </Desktop>
      </Box>
    </>
  );
};
